/**
 * La ficha de la app en Google Play.
 *
 * Mientras la app esté en prueba cerrada, este enlace solo abre para quien
 * está en la lista de testers; al resto Play le dice que no la encuentra.
 * Cuando pase a producción el enlace es el mismo y abre para todos: no hay
 * que cambiar nada aquí, solo el texto de `AppPromo` que avisa de la prueba.
 */
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.talent_hub';
